<template>
  <div>
    <template v-if="block === 'usBlock'">
      <component
        :is="usTag"
        :class="[
          'custom-font-1',
          tag != 'span' ? '' : 'span-h2',
          !getContrastYIQ($root.color_schema.primary) && sty
            ? 'text-white'
            : '',
          getContrastYIQ($root.color_schema.primary) && sty ? 'text-gray' : '',
        ]"
        >{{ title }}</component
      >
    </template>
    <template v-else-if="block === 'newCard'">
      <component
        :is="usTag"
        :class="[
          'custom-font-1 new-card-title',
          tag != 'span' ? '' : 'span-h2',
          sty === 'white' ? 'text-white' : '',
          sty === 'black' ? 'text-gray' : '',
        ]"
        >{{ title }}</component
      >
    </template>
    <template v-else-if="block === 'introBlock'">
      <component
        :is="usTag"
        :class="[
          'custom-font-1 intro-head',
          tag != 'span' ? '' : 'span-h2',
          !getContrastYIQ(sty) ? 'text-white' : '',
          getContrastYIQ(sty) ? 'text-gray' : '',
          titleAlign === 'left' ? 'head-left' : '',
          titleAlign === 'center' ? 'head-center' : '',
          titleAlign === 'right' ? 'head-right' : '',
        ]"
        >{{ title }}</component
      >
    </template>
    <template v-else-if="block === 'articleBanner'">
      <component :is="usTag" class="article-header">{{ title }}</component>
    </template>
    <template v-else-if="block === 'geoText'">
      <component
        :is="usTag"
        :class="[
          usTag === 'p' ? 'custom-font-2' : 'custom-font-1',
          tag != 'span' ? '' : 'span-h2',
        ]"
        >{{ title }}</component
      >
    </template>
    <template v-else-if="block === 'promoBanner'">
      <component :is="usTag" class="text-white no-margin">{{
        title
      }}</component>
    </template>
    <template v-else-if="block === 'gamepageBanner'">
      <component
        :is="usTag"
        :class="{ 'text-white gm-title': true, 'cust-h1': usTag === 'span' }"
        >{{ title }}</component
      >
    </template>
    <template v-else-if="block === 'homeBanner'">
      <component
        :is="usTag"
        :class="[sty === '' ? 'text-white' : '', 'home-ban-title']"
        :style="{ color: sty }"
        >{{ title }}</component
      >
    </template>
    <template v-else-if="block === 'homeBanner-second'">
      <component
        :is="usTag"
        :class="[sty === '' ? 'text-white' : '', 'home-font']"
        :style="{ color: sty }"
        >{{ title }}</component
      >
    </template>
    <template v-else-if="block === 'howto'">
      <component :is="usTag" :style="{ color: sty }">{{ title }}</component>
    </template>
    <template v-else-if="block === 'bestPayment'">
      <component
        :is="usTag"
        :class="[usTag === 'span' ? 'span-h2' : '', 'text-white']"
        >{{ title }}</component
      >
    </template>
    <template v-else-if="block === 'homePage'">
      <component :is="usTag">{{ title }}</component>
    </template>
    <template v-else-if="block === 'homePageTestimonial'">
      <component :is="usTag" :class="[usTag === 'span' ? 'span-h5' : '']">{{
        title
      }}</component>
    </template>
    <template v-else-if="block === 'blueProgressive'">
      <component :is="usTag" :class="[usTag === 'span' ? 'span-h3' : '']">{{
        title
      }}</component>
    </template>
    <template v-else-if="block === 'teamSection'">
      <component
        :is="usTag"
        :class="[
          usTag === 'span' ? 'span-h2' : '',
          sty === 'show' ? 'team-head-margin' : '',
          'team-header',
        ]"
        >{{ title }}</component
      >
    </template>
    <template v-else>
      <component
        :is="tag"
        :class="['custom-font-1', tag != 'span' ? '' : 'span-h2']"
        >{{ title }}</component
      >
    </template>
  </div>
</template>
<script>
import { pSBC, getContrastYIQ } from "@/misc/misc-function";
export default {
  name: "TagBlock",
  props: [
    "attrs",
    "title",
    "block",
    "usTag",
    "sty",
    "colorEnable",
    "titleAlign",
  ],
  computed: {
    tag() {
      if (this.attrs && this.attrs.hasOwnProperty("title_tag"))
        return this.attrs && this.attrs.hasOwnProperty("title_tag")
          ? this.attrs.title_tag
          : "span";
    },
  },
  methods: {
    pSBC,
    getContrastYIQ,
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";
.block-content {
  &-light {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    span {
      color: @white;
    }
  }
  &-gray {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    span {
      color: @gray;
    }
  }
}

.tg {
  margin-bottom: 0 !important;
  line-height: 20px !important;
}

.intro-head {
  @media (max-width: @sizes[small]) {
    line-height: 140% !important;
  }
}

.article-header {
  color: @white;
  margin: 0 10px 0 5px;
  @media (min-width: @sizes[medium]) {
    margin: 0 100px;
  }
}

.no-margin {
  margin: 20px 0;
  font-weight: 700;
}

.head {
  &-left {
    text-align: left;
  }
  &-center {
    text-align: center;
  }
  &-right {
    text-align: right;
  }
}

.home-font {
  font-size: 16px !important;
  margin-bottom: 10px !important;
  font-weight: bold;
  display: block;
  text-align: left !important;
  @media (min-width: @sizes[small]) {
    font-size: 18px !important;
    margin-bottom: 20px !important;
  }
}

.gm-title {
  text-align: left;
  line-height: 31px;
  @media (min-width: @sizes[large]) {
    text-align: center;
  }
}

.cust-h1 {
  font-size: 26px;
  line-height: 31px;
  font-weight: 900;
  margin: 0 0 16px 0;
  display: block;
}

.new-card-title {
  font-size: 22px;
}

.home-ban-title {
  @media (min-width: @sizes[large]) {
    max-width: 605px;
 }
}

.team-header {
  border-bottom: 1px solid #bdbdbe;
  padding-bottom: 16px;
}

.team-head-margin {
  margin-bottom: 32px;
  @media (min-width: @sizes[large]) {
    margin-bottom: 48px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/TagBlock.vue